/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import { FormattedMessage as FM } from 'react-intl';

const awaitTime = time => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

/**
 * 显示勾选的地点
 */
class ActiveSites extends React.Component {
  static propTypes = {
    mapKey: PropTypes.string,
    locations: PropTypes.array
  };
  static defaultProps = {};

  constructor(props) {
    super(props);
    this.containerId = uuidv4();
    this.state = {};
  }

  multiMarkerId = 1;
  multiCircleId = 1;
  map = null;

  componentDidMount = async () => {
    const { locations = [] } = this.props;
    if (!locations.length) return;

    await awaitTime(100);
    this.initMap();
    this.initMultiMarker();
    this.initMultiCycle();

    locations.forEach(location => {
      this.multiMarker.add({
        id: location.id,
        position: new TMap.LatLng(location.lat, location.lng)
      });
      this.multiCircle.add({
        id: location.id,
        center: new TMap.LatLng(location.lat, location.lng),
        radius: location.radius
      });
    });
  };

  initMap = () => {
    const { locations = [] } = this.props;
    const location = locations[0];
    const center = new TMap.LatLng(location.lat, location.lng); // 设置中心点坐标
    // 初始化地图
    this.map = new TMap.Map(this.containerId, {
      center: center
    });
  };

  multiMarker = null;
  initMultiMarker = () => {
    this.multiMarker = new TMap.MultiMarker({
      id: this.multiMarkerId,
      map: this.map
    });
  };

  multiCircle = null;
  initMultiCycle = () => {
    this.multiCircle = new TMap.MultiCircle({
      map: this.map,
      styles: {
        // 设置圆形样式
        circle: new TMap.CircleStyle({
          color: 'rgba(41,91,255,0.16)',
          showBorder: true,
          borderColor: 'rgba(41,91,255,1)',
          borderWidth: 2
        })
      }
    });
  };

  componentDidUpdate = (prevProps, prevState) => {
    // if (
    //   prevProps.locations !== this.props.locations &&
    //   this.props.locations &&
    //   this.multiMarker &&
    //   this.multiCircle
    // ) {
    //   console.log({locations: this.props.locations})
    //   this.props.locations.forEach(location => {
    //     this.multiMarker.add({
    //       id: location.id,
    //       position: new TMap.LatLng(location.lat, location.lng)
    //     });
    //     this.multiCircle.add({
    //       id: location.id,
    //       center: new TMap.LatLng(location.lat, location.lng),
    //       radius: location.radius
    //     });
    //   });
    // }
  };

  render() {
    const { locations = [], count } = this.props;
    if (!locations.length) {
      return (
        <div>
          <FM id="ClockInPlace.tipAddress" defaultMessage="请选择地点"></FM>
        </div>
      );
    }
    return (
      <div className="active-sites" onClick={this.handleClick}>
        <div className="active-sites__title">
          <FM
            id="ClockInPlace.allActiveSitesTitile"
            defaultMessage="所有选中地点的地图预览"
          />
          ({count})
        </div>
        <div id={this.containerId} style={{ width: '100%', height: 400 }} />
      </div>
    );
  }
}

export default ActiveSites;
